<template>
  <page-wrapper background="/static/img/anniversary/page-activities/bg.png" :swiper="swiper" :hasDownBtn="true">
    <div class="main-text ani" swiper-animate-effect="animate__fadeIn">
      近些年<br />吉凯每个月都会定期举办丰富多彩的<br />市场活动<br />您一共参加过<span class="text-highline">{{data.campaignTimes}}</span>活动
    </div>
    <div class="main-text-2 ani" swiper-animate-effect="animate__fadeIn" v-if="activities.length > 0">
      2024年之前 您参加了
      <p class="activities-list" v-for="i in [0, 1, 2]" :key="i">{{activities[i]}}</p>
      <p class="activities-list">{{activities.length > 3 ? '...' : ''}}</p>
    </div>

    <div class="main-text-3 ani" swiper-animate-effect="animate__fadeIn" v-if="activitiesThisYear.length > 0">
      今年您参加了
      <p class="activities-list" v-for="i in [0, 1, 2]" :key="i">{{activitiesThisYear[i]}}</p>
      <p class="activities-list">{{activitiesThisYear.length > 3 ? '...' : ''}}</p>
    </div>
  </page-wrapper>
</template>
<script>
import PageWrapper from '../PageWrapper.vue'

export default {
  components: { PageWrapper },
  props: [
    'swiper', 'data'
  ],
  computed: {
    activities () {
      return this.data.campaignNameBefore ? this.data.campaignNameBefore.split(',') : []
    },
    activitiesThisYear () {
      return this.data.campaignName ? this.data.campaignName.split(',') : []
    }
  }
}
</script>
<style lang="less" scoped>
.page-wrapper {
  .main-text, .main-text-2, .main-text-3 {
    position: absolute;
    width: 81.3vw;

    font-size: 4.26vw;
    line-height: 9.33vw;
    font-weight: 400;
    letter-spacing: -0.3px;
    z-index: 99;

    /* 字体 */
    color: #193543;

    .text-highline {
      font-size: 22px;
      font-weight: 600;
    }

    .text-notice {
      font-size: 16px;
      font-weight: 400;
    }
  }

  .main-text {
    margin-left: -40.65vw;
    left: 50%;
    top: 7.2vw;
  }

  .main-text-2 {
    position: absolute;
    right: 9.333333333vw;
    text-align: right;
    top: 50vw;
    width: 40vw;
    height: 46.6vw;
    // margin-top: -23.3vw;
  }

  .main-text-3 {
    left: 9.333333333vw;
    bottom: 12vw;
    width: 33.6vw;
    color: white;
  }

  .activities-list {
    line-height: 35px;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?533c44ed